import React, { createContext, useContext } from 'react';
// import { useConfirmation } from '../hooks/useConfirmation'; // Para cuando se implemente global

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  // const confirmation = useConfirmation(); // Implementar cuando ConfirmationService esté disponible

  // Aquí se pueden agregar más servicios globales en el futuro
  // Ejemplo: const auth = useAuth();
  // const notifications = useNotifications();

  const value = {
    // confirmation, // Descomentado cuando se implemente global
    // auth,
    // notifications,
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used within a GlobalProvider');
  }
  return context;
};